module.exports = __webpack_public_path__ + "static/728x90.7595a6a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/multimedia/2019/728x90.jpg
// module id = 566
// module chunks = 116596815971312